export default __webpack_public_path__ + "static/media/Button_H.74805617.svg";